import React from "react";
import ScholarshipForm from "./ScholarshipForm";

const Scholarship = () => {
  return (
    <div className="page-wrapper">
      <section className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12">
            <div className="sec-title" style={{ textAlign: "center" }}>
              <h1>Scholarship</h1>
              <div className="separator"></div>
            </div>

            <div className="widget widget_block">
              <div className="inner-container">
                <div className="row clearfix">
                  <div className="default-form">
                    <div className="title-box">
                      <ScholarshipForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Scholarship;
